import {getState, getActions, getMutations, getGetters} from "@admin100/djvue";

const actions = getActions("inspection/submissions");
const state = getState();
const getters = getGetters();
const mutations = getMutations();

const submission = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default submission;
